import Svg, { SvgProps, Path } from 'react-native-svg';

const UserIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M15 3a6 6 0 0 0-6 6v1a6 6 0 1 0 12 0V9a6 6 0 0 0-6-6zm-.002 16c-4.006 0-9.146 2.167-10.625 4.09C3.459 24.279 4.329 26 5.828 26H24.17c1.499 0 2.369-1.721 1.455-2.91C24.146 21.168 19.004 19 14.998 19z" />
  </Svg>
);

export default UserIcon;
